import { inject, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

import { default as _ } from "underscore";
import { default as routerHelper } from "helpers/routerHelper";
import { default as queryStringHelper } from "helpers/queryStringHelper";
import { default as ProductionBidItemService } from "services/production-bid-item-service";
import { ProgressionType } from "api/enums/progression-type"

import { NotificationHelper } from "helpers/notification-helper";
import { Router } from "aurelia-router";
import { FormBase } from "pages/form-base";
import { CloneHelper } from "helpers/cloneHelper";

@inject(I18N, ProductionBidItemService, ProgressionType, NotificationHelper, Router)
export default class ProductionBidItem extends FormBase {
    i18n;
    productionBidItemService;
    bidItems = [];
    changeNotices = [];
    dispatchProjectCode = null;
    dispatchDate = null;
    isProjectResponsible = false;
    readonly = true;
    unModified = null;

    @bindable commentOptions = {};

    constructor(i18n, productionBidItemService, progressionType, notificationHelper, router) {
        super(notificationHelper, i18n, router);
        this.productionBidItemService = productionBidItemService;
        this.progressionType = progressionType;

        this.commentOptions = {
            label: this.i18n.tr("Comment"),
            maxLength: 100,
        };
    }

    checkDirty() {
        if (!this.unModified) {
            return false;
        }

        const stringifyUnmodified = JSON.stringify(this.unModified).replace(/[^0-9A-Z]+/gi, "");

        const modified = this.bidItems.concat(this.changeNotices);
        const stringifyCurrent = JSON.stringify(modified).replace(/[^0-9A-Z]+/gi, "");

        return stringifyUnmodified !== stringifyCurrent;
    }

    bindViewModel(dispatchProjectCode, dispatchDate, queryString) {
        this.isProjectResponsible = queryStringHelper.parseIsProjectResponsible(queryString);

        this.dispatchDate = dispatchDate;
        this.dispatchProjectCode = dispatchProjectCode;
    }

    async loadData() {
        const result = await this.productionBidItemService.getProductionBidItem(this.dispatchProjectCode, this.dispatchDate);

        this.loaditem(result);
    }

    loaditem(data) {
        this.readonly = data.IsReadOnly;
        this.bidItems = data.BidItems;
        this.changeNotices = data.ChangeOrders;

        this.unModified = CloneHelper.deepClone(this.bidItems.concat(this.changeNotices));
    }

    validateData() {
        let isValid = true;

        _.each(this.bidItems, item => {
            if (item.Quantity < 0) {
                isValid = false;
            }
        });

        _.each(this.changeNotices, item => {
            if (item.Quantity < 0) {
                isValid = false;
            }
        });

        if (!isValid) {
            this.notificationHelper.showValidationError(() => {
                return [this.i18n.tr("err_MinQuantity")];
            });
        }

        return isValid;
    }

    activate(params) {
        this.bindViewModel(params.dispatchProjectCode, params.dailyEntryDate, params.q);

        return this.loadData();
    }

    change(item) {
        if (item.Quantity === "") {
            item.Quantity = 0
        }
    }

    async save() {
        if (!this.validateData()) {
            return;
        }

        const data = this.bidItems.concat(this.changeNotices);

        routerHelper.showLoading();

        try {
            this.unModified = null;
            await this.productionBidItemService.saveProductionBidItem(this.dispatchProjectCode, this.dispatchDate, data);

            routerHelper.navigateBack();
        } finally {
            routerHelper.hideLoading();
        }
    }
}
